<template>
  <div class="bg-ontick-carbon-500 flex min-h-screen justify-center pt-6 pb-32 sm:pt-16">
    <div
      class="flex w-full flex-col space-y-6 transition-all ease-in-out"
      :class="activeComponent === 'payment' ? 'sm:w-[1080px]' : 'sm:w-[667px]'"
    >
      <div class="flex items-center">
        <!-- <button class="p-4">
          <div>
            <i v-html="$icons.chevron_left"></i>
            <span class="sr-only"> Voltar </span>
          </div>
        </button> -->
        <div class="divide-ontick-green-600 flex transform items-center divide-x-2 pl-4 sm:scale-100 sm:pl-0">
          <router-link :to="{ name: 'Auth' }" class="nav-logo">
            <i v-html="$icons.logo" class="hidden sm:block"></i>
            <i v-html="$icons.small_logo" class="sm:hidden"></i>
            <span class="sr-only"> OnTick Invest </span>
          </router-link>
          <div class="nav-logo" v-if="checkoutData">
            <img
              :src="checkoutData.partner_logo"
              :alt="checkoutData.extension_owner"
              class="h-full max-h-[32px] w-full"
            />
            <span class="sr-only"> {{ checkoutData.extension_name }} </span>
          </div>
        </div>
      </div>
      <div v-if="is_logged" class="text-gray-400 text-sm flex flex-col items-start gap-1">
        <p>
          Logado como <span class="text-white font-bold">{{ getConfigs.user_name }}</span>
        </p>
        <button
          @click="login_modal_is_active = true"
          class="text-xs text-ontick-blue-600 hover:brightness-125 active:brightness-75"
        >
          Logar com outra conta
        </button>
        <button @click="signOut" class="text-xs text-ontick-red-600 hover:brightness-125 active:brightness-75">
          Deslogar
        </button>
      </div>
      <p v-else class="text-gray-400 text-sm">
        Já possui conta na OnTick?
        <button @click="login_modal_is_active = true" class="text-ontick-blue-600 font-bold inline">
          Faça o login.
        </button>
      </p>
      <transition name="fade" mode="out-in">
        <component
          :is="activeComponent"
          class="w-full px-4 sm:px-0"
          v-if="show"
          :emailInput="emailInput"
          :checkoutData="checkoutData"
          @emailInput="emailInput = $event"
          @goToRegisterCheck="activeComponent = 'register-check'"
          @registerCheck="activeComponent = 'register'"
        />
        <div v-else class="flex w-full items-center justify-center py-32">
          <div>
            <div class="animate-spin">
              <i v-html="$icons.spinner_lg"></i>
            </div>
            <span class="sr-only"> Carregando </span>
          </div>
        </div>
      </transition>
    </div>
    <portal to="modal">
      <ontick-modal :open="login_modal_is_active" @close="login_modal_is_active = false">
        <div class="flex flex-col gap-4 px-16">
          <div class="flex flex-col gap-2 items-center">
            <i v-html="$icons.logo"></i>
            <p class="text-white text-center text-sm">Entre com suas credenciais</p>
          </div>
          <OntickInputComponent
            :label="'Email'"
            v-model="login.email"
            name="username"
            :error="errors.first('username')"
            type="email"
            v-validate="'required|email'"
          ></OntickInputComponent>
          <OntickInputComponent
            :label="'Senha'"
            v-model="login.pwd"
            name="password"
            :error="errors.first('password')"
            type="password"
            v-validate="'required'"
          ></OntickInputComponent>
          <div class="flex flex-col items-center gap-2">
            <button
              @click="signIn"
              class="flex items-center hover:brightness-125 transition-all filter active:brightness-75 justify-center h-12 w-full text-sm rounded-md bg-ontick-blue-900 text-white font-semibold"
            >
              <i v-html="$icons.loading" v-if="loading"></i>
              <span v-else> Entrar </span>
            </button>
            <a href="#" class="text-sm text-ontick-blue-600 font-semibold text-center">Esqueci minha senha</a>
          </div>
        </div>
      </ontick-modal>
    </portal>
  </div>
</template>

<script>
import registerCheck from "../components/register-check.component.vue";
import register from "../components/register.component.vue";
import login from "../components/login.component.vue";
import payment from "../components/payment.component.vue";
import registerCode from "../components/register-code.component.vue";
import axios from "axios";
import { v4 } from "uuid";
import { Encrypt, Decrypt } from "../../../shared/utils/encrypt";
import event_bus from "../../../shared/utils/event_bus";
import OntickInputComponent from "../../../shared/components/basic/ontick-input.component.vue";
import { Auth } from "aws-amplify";
import { mapGetters } from "vuex";

export default {
  components: {
    registerCheck,
    register,
    login,
    payment,
    registerCode,
    OntickInputComponent,
  },

  data() {
    return {
      activeComponent: "payment",
      show: false,
      emailInput: "",
      checkoutData: null,
      checkoutError: null,
      login_modal_is_active: false,
      login: {
        email: "",
        pwd: "",
      },
      loading: false,
      is_logged: false,
    };
  },

  computed: {
    ...mapGetters({ getConfigs: "config/getConfigs" }),
  },

  methods: {
    async signIn() {
      this.loading = true;
      try {
        const valid = await this.$validator.validate();
        if (!valid) return;
        const auth_response = await Auth.signIn(this.login.email, this.login.pwd);
        const { form_type } = auth_response;
        if (["SMS_MFA", "SOFTWARE_TOKEN_MFA", "NEW_PASSWORD_REQUIRED"].includes(form_type)) {
          this.$router.push({ name: "Auth" });
        } else {
          event_bus.$emit("LOGIN_SUCCESSFUL");
          this.login_modal_is_active = false;
        }
      } catch (err) {
        console.error(err);
        this.$swal("Erro", err.message, "error");
      } finally {
        this.loading = false;
      }
    },
    async signOut() {
      try {
        await Auth.signOut();
        this.is_logged = false;
      } catch (err) {
        console.error(err);
      }
    },
    getCheckoutData() {
      return new Promise((resolve, reject) => {
        let uuidv4 = v4();

        let uuidKey = "".padStart(32, uuidv4.slice(0, 4));
        let checkoutKey = "".padStart(32, this.$route.params.checkout_code.slice(0, 4));

        let payload = {
          checkout: this.$route.params.checkout_code,
          coupon: this.$route.query.coupon,
          uuidv4,
        };

        let data = {
          checkout: this.$route.params.checkout_code,
          coupon: this.$route.query.coupon,
          p: Encrypt(JSON.stringify(payload), checkoutKey),
        };

        let config = {
          headers: {
            authorization: uuidv4,
          },
          params: {
            hash: Encrypt(uuidv4, uuidKey),
          },
        };

        axios
          .post(this.$endpoint.GET_CHECKOUT_DATA, data, config)
          .then((res) => {
            this.checkoutData = res.data;
            // delete this.checkoutData.coupon_data;
            resolve(res);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },
  },

  created() {
    event_bus.$on("addCoupon", (data) => {
      this.checkoutData.coupon_data = data;
      this.checkoutData = {
        ...this.checkoutData,
        ...data,
      };
    });
  },

  async mounted() {
    this.getCheckoutData().finally(() => {
      this.show = true;
    });

    const auth = await Auth.currentSession();
    if (auth) {
      this.is_logged = true;
    } else {
      this.is_logged = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.nav-logo {
  @apply px-4 first:pl-0 last:pr-0;
}
.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-500 ease-in-out;
  }
  // &-enter-to,
  // &-leave {
  //   @apply scale-125 opacity-0;
  // }
}
</style>
